<div class="mt-20 flex w-full items-center justify-center">
	<div>
		No conversations selected.
		<div class="mt-20 flex justify-center text-neutral-400 dark:text-neutral-500">Have a good day 😃.</div>
	</div>
</div>
